import styled from 'styled-components';
import { CardBody as CardBodyC } from 'reactstrap';

export const IdOrcamentoLabel = styled.label`
  color: #8898aa;
  font-size: 1.4rem;
  font-weight: 600;
`;

export const GridDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  overflow: hidden;
`;

export const CardBodyPai = styled(CardBodyC)`
  overflow: auto;
  height: 45vh;
`;

export const CardBody = styled(CardBodyC)``;

// export const RowButtons = styled.div`
//   display: flex;
//   flex-direction: row;
//   justify-content: flex-end;
// `;

export const RowButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px; /* Increased from 12px to 16px for better spacing */
  flex-wrap: wrap;
  margin-left: auto;

  /* Add some responsive behavior */
  @media (max-width: 1200px) {
    gap: 12px;
  }

  @media (max-width: 992px) {
    justify-content: flex-start;
    margin-top: 10px;
    gap: 10px;
  }

  @media (max-width: 768px) {
    gap: 8px;
    flex-direction: column;
    align-items: flex-start;
  }

  /* Style for the toggle containers */
  .btn-icon {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;

    @media (max-width: 992px) {
      white-space: normal;
    }
  }

  /* Style for the buttons */
  .btn {
    margin: 0;
  }
`;
